import React from 'react';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { BrowserRouter } from 'react-router-dom'
import RouterConfig from './utils/RouterConfig';
import config from './utils/Config';


function App() {

  // if (window.location.pathname === "/") {
  //   window.location.replace(config.baseName)
  // }
  return (
    <>
      <BrowserRouter basename={config.baseName}>
        <div className="App">
          <RouterConfig></RouterConfig>
          <ToastContainer theme="colored"
          ></ToastContainer>
        </div>
      </BrowserRouter>
    </>
  );

 
}



export default App;
